import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

export const Presentation: React.FC = () => {
  const { t } = useTranslation();
  const title = t('ui.oidc.callback.error.title');
  const content = t('ui.oidc.callback.error.content');
  const btnHome = t('ui.oidc.callback.error.btnHome');

  return (
    <Segment textAlign="center" basic>
      <div>
        <Title>{title}</Title>
        <Content>
          <span>{content}</span>
        </Content>
        <HomeButton>
          <Button primary as={Link} to="/" className="home-button">
            {btnHome}
          </Button>
        </HomeButton>
      </div>
    </Segment>
  );
};

const Title = styled.h1`
  font-weight: 400;
  font-size: 2.3rem;
`;

const Content = styled.div`
  color: #db3333;
  padding-top: 30px;
  font-size: 1.3rem;
`;

const HomeButton = styled.div`
  margin-top: 130px;
  .home-button {
    line-height: 30px;
    minwidth: 150px;
    fontsize: 1.3rem;
  }
`;
